import {Base} from "@/api/Base"

export class RemainingVacationDelete extends Base {
    path = "remainingVacation/delete"
}